import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';
import Button from 'packages/ui/Button';
import { Link } from 'react-router-dom';

const CirclesList = React.lazy(() => import('./Circles'));

function Circles(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>دایره‌ها</PageTitle>
        <Button as={Link} type="anchor" to="/circles/new">
          دایره جدید
        </Button>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <CirclesList {...props} />
      </Suspense>
    </Page>
  );
}

export default Circles;
